import { useTheme } from '@emotion/react';
import { Box, useMediaQuery } from '@mui/material';
import React from 'react';

const PersonalIcon = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 6C1.25 2.82436 3.82436 0.25 7 0.25H56.75V55.75H7C3.82436 55.75 1.25 53.1756 1.25 50V6Z"
        fill="#E1F2FE"
        fill-opacity="0.62"
        stroke="#0065FC"
        stroke-width="0.5"
      />
      <path
        d="M17 41.4291V39.7148C17 33.0874 22.3726 27.7148 29 27.7148C35.6274 27.7148 41 33.0874 41 39.7148V41.4291"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29 27.7143C32.7871 27.7143 35.8572 24.6442 35.8572 20.8571C35.8572 17.07 32.7871 14 29 14C25.2129 14 22.1429 17.07 22.1429 20.8571C22.1429 24.6442 25.2129 27.7143 29 27.7143Z"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const PersonalIconActive = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 6C1.25 2.82436 3.82436 0.25 7 0.25H56.75V55.75H7C3.82436 55.75 1.25 53.1756 1.25 50V6Z"
        fill="#0065FC"
        fill-opacity="0.62"
        stroke="#E1F2FE"
        stroke-width="0.5"
      />
      <path
        d="M17 41.4291V39.7148C17 33.0874 22.3726 27.7148 29 27.7148C35.6274 27.7148 41 33.0874 41 39.7148V41.4291"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29 27.7143C32.787 27.7143 35.8572 24.6442 35.8572 20.8571C35.8572 17.07 32.787 14 29 14C25.2129 14 22.1429 17.07 22.1429 20.8571C22.1429 24.6442 25.2129 27.7143 29 27.7143Z"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const MoneyIcon = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 6C1.25 2.82436 3.82436 0.25 7 0.25H56.75V55.75H7C3.82436 55.75 1.25 53.1756 1.25 50V6Z"
        fill="#E1F2FE"
        fill-opacity="0.62"
        stroke="#0065FC"
        stroke-width="0.5"
      />
      <g clip-path="url(#clip0_33368_144489)">
        <path
          d="M22.8858 26.0148L22.8847 26.0339C22.8108 27.3285 23.5359 28.5413 24.7327 29.1228L24.7449 29.1288C25.1668 29.3306 25.5127 29.6633 25.7308 30.077L25.7357 30.086C26.3387 31.2342 27.5859 31.9302 28.9154 31.8604L28.9356 31.8593C29.4178 31.8323 29.8964 31.9567 30.3044 32.2152C31.4303 32.9194 32.8593 32.9194 33.9851 32.2152C34.3931 31.9567 34.8718 31.8323 35.354 31.8593L35.3741 31.8604C36.7015 31.9307 37.9503 31.2342 38.5547 30.0841L38.5577 30.0779C38.7767 29.663 39.1233 29.3298 39.5466 29.1277L39.5564 29.1228C40.7531 28.541 41.4786 27.3285 41.4044 26.0336L41.4033 26.0156C41.3787 25.5596 41.5053 25.1082 41.7638 24.7316C42.5081 23.6462 42.5081 22.2149 41.7641 21.1292C41.5058 20.7528 41.3787 20.3017 41.4033 19.8457L41.4044 19.8266C41.4786 18.5317 40.7531 17.3192 39.5553 16.7372L39.5444 16.7318C39.1233 16.5305 38.7783 16.1994 38.5598 15.7868L38.5536 15.7745C37.9503 14.6263 36.7015 13.9306 35.3741 14.0001L35.3537 14.0012C34.8718 14.0282 34.3931 13.9039 33.9854 13.6453H33.9849C32.8591 12.9411 31.43 12.9411 30.3042 13.6453C29.8962 13.9036 29.4175 14.028 28.9354 14.001L28.9152 13.9999C27.5875 13.9295 26.339 14.626 25.736 15.7739L25.7314 15.7824C25.5129 16.1969 25.1668 16.5299 24.7444 16.732L24.7329 16.7375C23.5362 17.3189 22.8108 18.5317 22.8849 19.8266L22.886 19.8446C22.9106 20.3006 22.784 20.752 22.5255 21.1284C21.7812 22.2141 21.7812 23.6456 22.5255 24.7311C22.7838 25.1074 22.9106 25.5588 22.8858 26.0148ZM23.4448 21.7627C23.8438 21.1818 24.0394 20.4853 24.0012 19.7816L24.0001 19.7626C23.9608 18.9046 24.4425 18.1077 25.22 17.743L25.2296 17.7384C25.8675 17.4329 26.3897 16.93 26.7192 16.3044L26.7246 16.294C27.1253 15.5309 27.9645 15.0684 28.8557 15.1159L28.8754 15.1167C29.5885 15.1568 30.2963 14.9729 30.8995 14.5906C31.6612 14.1141 32.6278 14.1141 33.3895 14.5906C33.9928 14.9724 34.7005 15.1565 35.4134 15.1169L35.433 15.1159C36.3287 15.0689 37.1638 15.5309 37.5633 16.2918L37.5707 16.3058C37.9001 16.9306 38.4218 17.4327 39.0589 17.7378L39.0682 17.7425C39.858 18.1265 40.3375 18.9193 40.2892 19.7628L40.2881 19.7827C40.2499 20.4864 40.4457 21.1826 40.8447 21.7635C41.3269 22.4669 41.3266 23.3942 40.8442 24.0973C40.4455 24.6784 40.2499 25.375 40.2881 26.0786L40.2892 26.0974C40.3375 26.941 39.858 27.734 39.0679 28.1183L39.0597 28.1221C38.4213 28.4281 37.8985 28.9316 37.5688 29.5583L37.5647 29.5665C37.1638 30.3296 36.3259 30.7924 35.4333 30.7447L35.414 30.7436C34.7008 30.7038 33.9928 30.8878 33.3892 31.2699C32.6278 31.7461 31.6612 31.7461 30.8998 31.2699C30.3511 30.9222 29.7145 30.7378 29.0649 30.7384C29.0019 30.7384 28.9386 30.74 28.8754 30.7436L28.8557 30.7444C27.9762 30.8003 27.1441 30.3399 26.7238 29.5651L26.7181 29.5545C26.3892 28.9299 25.8677 28.4281 25.2309 28.123L25.2206 28.1178C24.4305 27.7338 23.951 26.9407 23.9996 26.0974L24.0007 26.0775C24.0386 25.3739 23.8428 24.6773 23.444 24.0967C22.9621 23.3933 22.9624 22.4661 23.4448 21.7633V21.7627Z"
          fill="#0065FC"
        />
        <path
          d="M35.3133 25.478C35.3133 26.1967 35.0473 26.8313 34.5153 27.382C33.9833 27.9327 33.2553 28.25 32.3313 28.334V29.468H31.5333V28.334C30.6373 28.2687 29.9139 28.0027 29.3633 27.536C28.8126 27.06 28.5373 26.4347 28.5373 25.66H30.2453C30.3106 26.4533 30.7399 26.9107 31.5333 27.032V23.952C30.6839 23.756 30.0866 23.5553 29.7413 23.35C29.3213 23.1073 29.0319 22.846 28.8733 22.566C28.6493 22.174 28.5373 21.726 28.5373 21.222C28.5373 20.4287 28.8126 19.78 29.3633 19.276C29.9139 18.772 30.6373 18.4827 31.5333 18.408V17.274H32.3313V18.408C33.1713 18.4733 33.8433 18.73 34.3473 19.178C34.8606 19.6167 35.1499 20.228 35.2153 21.012H33.5073C33.4793 20.7133 33.3579 20.4473 33.1433 20.214C32.9379 19.9807 32.6673 19.8267 32.3313 19.752V22.776C33.2179 22.9813 33.8106 23.1727 34.1093 23.35C34.5479 23.6207 34.8233 23.8587 34.9353 24.064C35.1873 24.5027 35.3133 24.974 35.3133 25.478ZM31.5333 19.71C31.1133 19.766 30.7773 19.9153 30.5253 20.158C30.2826 20.3913 30.1613 20.7133 30.1613 21.124C30.1613 21.5253 30.2779 21.8333 30.5113 22.048C30.7539 22.2627 31.0946 22.4353 31.5333 22.566V19.71ZM32.3313 27.032C32.7606 26.9667 33.0966 26.8033 33.3393 26.542C33.5819 26.2713 33.7033 25.9493 33.7033 25.576C33.7033 25.1933 33.5819 24.8947 33.3393 24.68C33.1059 24.4653 32.7699 24.2927 32.3313 24.162V27.032Z"
          fill="#0065FC"
        />
        <path
          d="M43.9275 34.9919C43.1878 33.6792 41.5477 33.1793 40.2018 33.8562L35.8264 35.9235C35.2224 34.8001 34.0635 34.0851 32.7883 34.0491L28.7492 33.9378C28.1097 33.9195 27.4821 33.7572 26.9135 33.4638L26.5025 33.2508C24.3981 32.1539 21.8899 32.1566 19.7877 33.2579L19.8134 32.3268C19.8218 32.0183 19.5788 31.7614 19.2704 31.753L14.8413 31.6311C14.5328 31.6226 14.2762 31.8656 14.2678 32.1741L14.0002 41.8937C13.9918 42.2022 14.2348 42.4591 14.5432 42.4676L18.9723 42.5895H18.9878C19.2903 42.5892 19.5376 42.3484 19.5461 42.0462L19.5586 41.5812L20.7093 40.9651C21.1609 40.7221 21.6892 40.6643 22.1825 40.8039L29.0533 42.7324C29.0653 42.7359 29.0773 42.7386 29.0896 42.7414C29.5862 42.8453 30.0924 42.8974 30.5999 42.8971C31.6745 42.8976 32.7365 42.6661 33.7131 42.2177C33.7371 42.2068 33.7603 42.1943 33.7824 42.1801L43.7445 35.7359C43.9929 35.5755 44.0731 35.2491 43.9275 34.9919ZM15.1323 41.366L15.369 32.7634L18.6815 32.8545L18.4445 41.4574L15.1323 41.366ZM33.2096 41.2196C31.9963 41.7672 30.6411 41.9183 29.3369 41.6516L22.4844 39.7286C21.7134 39.5104 20.8876 39.6009 20.1821 39.9803L19.5941 40.295L19.7517 34.5751C21.6147 33.3359 24.0043 33.2085 25.9887 34.2424L26.3997 34.4554C27.118 34.8263 27.9106 35.0311 28.7187 35.0543L32.7577 35.1656C33.8923 35.1981 34.8558 36.0059 35.086 37.1175L29.0697 36.9519C28.7612 36.9435 28.5046 37.1865 28.4961 37.4949C28.4877 37.8034 28.7307 38.0603 29.0391 38.0688L35.6786 38.2515H35.6944C35.9966 38.2512 36.244 38.0104 36.2524 37.7082C36.2593 37.4655 36.241 37.2225 36.1984 36.9836L40.6853 34.8631L40.6984 34.8569C41.3349 34.5345 42.1049 34.6422 42.6282 35.1269L33.2096 41.2196Z"
          fill="#0065FC"
        />
      </g>
      <defs>
        <clipPath id="clip0_33368_144489">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(14 13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const MoneyIconActive = () => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 6C1.25 2.82436 3.82436 0.25 7 0.25H56.75V55.75H7C3.82436 55.75 1.25 53.1756 1.25 50V6Z"
        fill="#0065FC"
        fill-opacity="0.62"
        stroke="#E1F2FE"
        stroke-width="0.5"
      />
      <g clip-path="url(#clip0_33368_145603)">
        <path
          d="M23.8858 26.0148L23.8847 26.0339C23.8108 27.3285 24.5359 28.5413 25.7327 29.1228L25.7449 29.1288C26.1668 29.3306 26.5127 29.6633 26.7308 30.077L26.7357 30.086C27.3387 31.2342 28.5859 31.9302 29.9154 31.8604L29.9356 31.8593C30.4178 31.8323 30.8964 31.9567 31.3044 32.2152C32.4303 32.9194 33.8593 32.9194 34.9851 32.2152C35.3931 31.9567 35.8718 31.8323 36.354 31.8593L36.3741 31.8604C37.7015 31.9307 38.9503 31.2342 39.5547 30.0841L39.5577 30.0779C39.7767 29.663 40.1233 29.3298 40.5466 29.1277L40.5564 29.1228C41.7531 28.541 42.4786 27.3285 42.4044 26.0336L42.4033 26.0156C42.3787 25.5596 42.5053 25.1082 42.7638 24.7316C43.5081 23.6462 43.5081 22.2149 42.7641 21.1292C42.5058 20.7528 42.3787 20.3017 42.4033 19.8457L42.4044 19.8266C42.4786 18.5317 41.7531 17.3192 40.5553 16.7372L40.5444 16.7318C40.1233 16.5305 39.7783 16.1994 39.5598 15.7868L39.5536 15.7745C38.9503 14.6263 37.7015 13.9306 36.3741 14.0001L36.3537 14.0012C35.8718 14.0282 35.3931 13.9039 34.9854 13.6453H34.9849C33.8591 12.9411 32.43 12.9411 31.3042 13.6453C30.8962 13.9036 30.4175 14.028 29.9354 14.001L29.9152 13.9999C28.5875 13.9295 27.339 14.626 26.736 15.7739L26.7314 15.7824C26.5129 16.1969 26.1668 16.5299 25.7444 16.732L25.7329 16.7375C24.5362 17.3189 23.8108 18.5317 23.8849 19.8266L23.886 19.8446C23.9106 20.3006 23.784 20.752 23.5255 21.1284C22.7812 22.2141 22.7812 23.6456 23.5255 24.7311C23.7838 25.1074 23.9106 25.5588 23.8858 26.0148ZM24.4448 21.7627C24.8438 21.1818 25.0394 20.4853 25.0012 19.7816L25.0001 19.7626C24.9608 18.9046 25.4425 18.1077 26.22 17.743L26.2296 17.7384C26.8675 17.4329 27.3897 16.93 27.7192 16.3044L27.7246 16.294C28.1253 15.5309 28.9645 15.0684 29.8557 15.1159L29.8754 15.1167C30.5885 15.1568 31.2963 14.9729 31.8995 14.5906C32.6612 14.1141 33.6278 14.1141 34.3895 14.5906C34.9928 14.9724 35.7005 15.1565 36.4134 15.1169L36.433 15.1159C37.3287 15.0689 38.1638 15.5309 38.5633 16.2918L38.5707 16.3058C38.9001 16.9306 39.4218 17.4327 40.0589 17.7378L40.0682 17.7425C40.858 18.1265 41.3375 18.9193 41.2892 19.7628L41.2881 19.7827C41.2499 20.4864 41.4457 21.1826 41.8447 21.7635C42.3269 22.4669 42.3266 23.3942 41.8442 24.0973C41.4455 24.6784 41.2499 25.375 41.2881 26.0786L41.2892 26.0974C41.3375 26.941 40.858 27.734 40.0679 28.1183L40.0597 28.1221C39.4213 28.4281 38.8985 28.9316 38.5688 29.5583L38.5647 29.5665C38.1638 30.3296 37.3259 30.7924 36.4333 30.7447L36.414 30.7436C35.7008 30.7038 34.9928 30.8878 34.3892 31.2699C33.6278 31.7461 32.6612 31.7461 31.8998 31.2699C31.3511 30.9222 30.7145 30.7378 30.0649 30.7384C30.0019 30.7384 29.9386 30.74 29.8754 30.7436L29.8557 30.7444C28.9762 30.8003 28.1441 30.3399 27.7238 29.5651L27.7181 29.5545C27.3892 28.9299 26.8677 28.4281 26.2309 28.123L26.2206 28.1178C25.4305 27.7338 24.951 26.9407 24.9996 26.0974L25.0007 26.0775C25.0386 25.3739 24.8428 24.6773 24.444 24.0967C23.9621 23.3933 23.9624 22.4661 24.4448 21.7633V21.7627Z"
          fill="#E1F2FE"
        />
        <path
          d="M36.3133 25.478C36.3133 26.1967 36.0473 26.8313 35.5153 27.382C34.9833 27.9327 34.2553 28.25 33.3313 28.334V29.468H32.5333V28.334C31.6373 28.2687 30.9139 28.0027 30.3633 27.536C29.8126 27.06 29.5373 26.4347 29.5373 25.66H31.2453C31.3106 26.4533 31.7399 26.9107 32.5333 27.032V23.952C31.6839 23.756 31.0866 23.5553 30.7413 23.35C30.3213 23.1073 30.0319 22.846 29.8733 22.566C29.6493 22.174 29.5373 21.726 29.5373 21.222C29.5373 20.4287 29.8126 19.78 30.3633 19.276C30.9139 18.772 31.6373 18.4827 32.5333 18.408V17.274H33.3313V18.408C34.1713 18.4733 34.8433 18.73 35.3473 19.178C35.8606 19.6167 36.1499 20.228 36.2153 21.012H34.5073C34.4793 20.7133 34.3579 20.4473 34.1433 20.214C33.9379 19.9807 33.6673 19.8267 33.3313 19.752V22.776C34.2179 22.9813 34.8106 23.1727 35.1093 23.35C35.5479 23.6207 35.8233 23.8587 35.9353 24.064C36.1873 24.5027 36.3133 24.974 36.3133 25.478ZM32.5333 19.71C32.1133 19.766 31.7773 19.9153 31.5253 20.158C31.2826 20.3913 31.1613 20.7133 31.1613 21.124C31.1613 21.5253 31.2779 21.8333 31.5113 22.048C31.7539 22.2627 32.0946 22.4353 32.5333 22.566V19.71ZM33.3313 27.032C33.7606 26.9667 34.0966 26.8033 34.3393 26.542C34.5819 26.2713 34.7033 25.9493 34.7033 25.576C34.7033 25.1933 34.5819 24.8947 34.3393 24.68C34.1059 24.4653 33.7699 24.2927 33.3313 24.162V27.032Z"
          fill="#E1F2FE"
        />
        <path
          d="M44.9275 34.9919C44.1879 33.6792 42.5477 33.1793 41.2018 33.8562L36.8265 35.9235C36.2224 34.8001 35.0636 34.0851 33.7883 34.0491L29.7493 33.9378C29.1097 33.9195 28.4822 33.7572 27.9136 33.4638L27.5026 33.2508C25.3982 32.1539 22.89 32.1566 20.7878 33.2579L20.8134 32.3268C20.8219 32.0183 20.5789 31.7614 20.2704 31.753L15.8414 31.6311C15.5329 31.6226 15.2763 31.8656 15.2678 32.1741L15.0003 41.8937C14.9918 42.2022 15.2348 42.4591 15.5433 42.4676L19.9723 42.5895H19.9879C20.2903 42.5892 20.5377 42.3484 20.5461 42.0462L20.5587 41.5812L21.7093 40.9651C22.161 40.7221 22.6892 40.6643 23.1826 40.8039L30.0534 42.7324C30.0654 42.7359 30.0774 42.7386 30.0896 42.7414C30.5863 42.8453 31.0924 42.8974 31.6 42.8971C32.6745 42.8976 33.7365 42.6661 34.7131 42.2177C34.7371 42.2068 34.7603 42.1943 34.7824 42.1801L44.7445 35.7359C44.993 35.5755 45.0732 35.2491 44.9275 34.9919ZM16.1324 41.366L16.3691 32.7634L19.6816 32.8545L19.4446 41.4574L16.1324 41.366ZM34.2097 41.2196C32.9963 41.7672 31.6412 41.9183 30.337 41.6516L23.4845 39.7286C22.7135 39.5104 21.8877 39.6009 21.1821 39.9803L20.5941 40.295L20.7518 34.5751C22.6148 33.3359 25.0044 33.2085 26.9887 34.2424L27.3997 34.4554C28.1181 34.8263 28.9106 35.0311 29.7187 35.0543L33.7578 35.1656C34.8923 35.1981 35.8559 36.0059 36.086 37.1175L30.0697 36.9519C29.7613 36.9435 29.5046 37.1865 29.4962 37.4949C29.4877 37.8034 29.7307 38.0603 30.0392 38.0688L36.6787 38.2515H36.6945C36.9967 38.2512 37.244 38.0104 37.2525 37.7082C37.2593 37.4655 37.241 37.2225 37.1985 36.9836L41.6854 34.8631L41.6985 34.8569C42.335 34.5345 43.1049 34.6422 43.6283 35.1269L34.2097 41.2196Z"
          fill="#E1F2FE"
        />
      </g>
      <defs>
        <clipPath id="clip0_33368_145603">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(15 13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const HomeIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.25 6C0.25 2.82436 2.82436 0.25 6 0.25H55.75V55.75H6C2.82436 55.75 0.25 53.1756 0.25 50V6Z"
        fill="#E1F2FE"
        fill-opacity="0.62"
        stroke="#0065FC"
        stroke-width="0.5"
      />
      <path
        d="M24 32C27 32 40 32 40 32"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 32C18.375 32 20 32 20 32"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 37C18.375 37 20 37 20 37"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 42C18.375 42 20 42 20 42"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 37L40 37"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 42H40"
        stroke="#0065FC"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M43.6832 28.7617C43.7836 28.6622 43.8633 28.5437 43.9176 28.4132C43.972 28.2826 44 28.1427 44 28.0013C44 27.8599 43.972 27.7199 43.9176 27.5893C43.8633 27.4588 43.7836 27.3404 43.6832 27.2408L29.7595 13.3168C29.66 13.2164 29.5415 13.1368 29.411 13.0824C29.2805 13.028 29.1405 13 28.9991 13C28.8577 13 28.7177 13.028 28.5872 13.0824C28.4567 13.1368 28.3382 13.2164 28.2386 13.3168L14.315 27.2408C14.1133 27.4425 14 27.716 14 28.0013C14 28.2865 14.1133 28.56 14.315 28.7617C14.5167 28.9634 14.7902 29.0767 15.0754 29.0767C15.3607 29.0767 15.6342 28.9634 15.8359 28.7617L28.9991 15.5875L42.1623 28.7617C42.2619 28.8621 42.3803 28.9418 42.5108 28.9962C42.6414 29.0505 42.7813 29.0785 42.9227 29.0785C43.0641 29.0785 43.2041 29.0505 43.3346 28.9962C43.4652 28.9418 43.5836 28.8621 43.6832 28.7617Z"
        fill="#0065FC"
      />
    </svg>
  );
};

const HomeIconActive = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.25 6C0.25 2.82436 2.82436 0.25 6 0.25H55.75V55.75H6C2.82436 55.75 0.25 53.1756 0.25 50V6Z"
        fill="#0065FC"
        fill-opacity="0.62"
        stroke="#E1F2FE"
        stroke-width="0.5"
      />
      <path
        d="M24 32C27 32 40 32 40 32"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 32C18.375 32 20 32 20 32"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 37C18.375 37 20 37 20 37"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 42C18.375 42 20 42 20 42"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 37L40 37"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 42H40"
        stroke="#E1F2FE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M43.6832 28.7617C43.7836 28.6622 43.8633 28.5437 43.9176 28.4132C43.972 28.2826 44 28.1427 44 28.0013C44 27.8599 43.972 27.7199 43.9176 27.5893C43.8633 27.4588 43.7836 27.3404 43.6832 27.2408L29.7595 13.3168C29.66 13.2164 29.5415 13.1368 29.411 13.0824C29.2805 13.028 29.1405 13 28.9991 13C28.8577 13 28.7177 13.028 28.5872 13.0824C28.4567 13.1368 28.3382 13.2164 28.2386 13.3168L14.315 27.2408C14.1133 27.4425 14 27.716 14 28.0013C14 28.2865 14.1133 28.56 14.315 28.7617C14.5167 28.9634 14.7902 29.0767 15.0754 29.0767C15.3607 29.0767 15.6342 28.9634 15.8359 28.7617L28.9991 15.5875L42.1623 28.7617C42.2619 28.8621 42.3803 28.9418 42.5108 28.9962C42.6414 29.0505 42.7813 29.0785 42.9227 29.0785C43.0641 29.0785 43.2041 29.0505 43.3346 28.9962C43.4652 28.9418 43.5836 28.8621 43.6832 28.7617Z"
        fill="#E1F2FE"
      />
    </svg>
  );
};

const BuyerDetailsNavigation = ({
  handleLeftArrowClick,
  togglePopupShow,
  setBuyerDetailNavigation,
  buyerDetailNavigation,
  setPropertySelected,
  scrollToTopContainer,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  const smoothScroll = () => {
    if (scrollToTopContainer.current) {
      scrollToTopContainer.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        right: 0,
        top: matchessm ? '300px' : matchesmd ? '350px' : '450px',
        zIndex: 2,
      }}
    >
      <Box
        onClick={() => {
          setBuyerDetailNavigation('Profile');
          setPropertySelected(false);
          if (matchessm) {
            smoothScroll();
          }
        }}
      >
        {buyerDetailNavigation === 'Profile' ? (
          <PersonalIconActive />
        ) : (
          <PersonalIcon />
        )}
      </Box>
      <Box
        onClick={() => {
          setBuyerDetailNavigation('Activity');
          setPropertySelected(false);
          if (matchessm) {
            smoothScroll();
          }
        }}
      >
        {buyerDetailNavigation === 'Activity' ? (
          <MoneyIconActive />
        ) : (
          <MoneyIcon />
        )}
      </Box>
      <Box
        onClick={() => {
          setBuyerDetailNavigation('Offers');
          if (matchessm) {
            smoothScroll();
          }
        }}
      >
        {buyerDetailNavigation === 'Offers' ? <HomeIconActive /> : <HomeIcon />}
      </Box>
    </Box>
  );
};

export default BuyerDetailsNavigation;
